const fs = require('fs');
const glob = require('glob');
const path = require('path');
const {extractDescription} = require('@wix/artifact-description');


export function getTranslationSpecs(options = {}) {
  try {
    const specProps = getSpecProps(options);
    const files = glob.sync(path.join(options.base || process.cwd(), options.path || '/@(app|src)/**/*_en.json'));
    return files.reduce((specs, fileName) => {
      const singleFileSpecs = createSpecsFromFile(fileName, specProps);
      return Object.assign(specs, singleFileSpecs);
    }, {});
  } catch (e) {
    console.warn('ab-translate - could not find translation keys', e);
    return {};
  }
}

const defaultSpecProps = {
  onlyForLoggedInUsers: true
};

function getSpecProps(options) {
  const specProps = {
    ...defaultSpecProps,
    ...getProjectProps(options)
  };

  if ('onlyForLoggedInUsers' in options) {
    specProps.onlyForLoggedInUsers = options.onlyForLoggedInUsers;
  }

  if ('scopes' in options) {
    specProps.scopes = options.scopes;
  }

  if ('owner' in options) {
    specProps.owner = options.owner;
  }

  return specProps;
}

function getProjectProps(options) {
  let description;

  try {
    description = extractDescription(options.cwd || process.cwd());
  } catch (e) {
    console.warn('[ab-translate] failed to extract artifact description: ', e);
    return {owner: '', scopes: []};
  }

  if (!description.key) {
    console.warn('[ab-translate] invalid artifact ID');
    return {owner: '', scopes: []};
  }

  return {
    owner: description.contributors.length > 0 ? description.contributors[0].email : '',
    scopes: [description.key.artifactId],
  };
}

function createSpecsFromFile(fileName, {owner, scopes, onlyForLoggedInUsers}) {
  try {
    const fileContent = JSON.parse(fs.readFileSync(fileName, 'utf-8'));
    return Object.keys(fileContent)
      .filter(translationKey => /.*\|abTranslate_\d+\|?.*/.test(translationKey))
      .reduce((acc, translationKey) => {
        const [, baseTranslationKey, group, specName] = /(.*)\|abTranslate_(\d+)\|?(.*)/.exec(translationKey);
        const specKey = `specs.abTranslate.${scopes[0]}.${specName ? 'abSpec-' + specName : baseTranslationKey}`;
        if (!acc[specKey]) {
          acc[specKey] = {
            owner,
            scopes,
            onlyForLoggedInUsers,
            controlGroup: '0',
            variants: [group]
          };
        } else if (!acc[specKey].variants.includes(group)) {
          acc[specKey].variants.push(group);
        }
        return acc;
      }, {});
  } catch (e) {
    console.warn('ab-translate - could not read file', fileName);
    return {};
  }
}
